import { render, staticRenderFns } from "./unfairModal.vue?vue&type=template&id=507252a8&scoped=true&"
import script from "./unfairModal.vue?vue&type=script&lang=js&"
export * from "./unfairModal.vue?vue&type=script&lang=js&"
import style0 from "./unfairModal.vue?vue&type=style&index=0&id=507252a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507252a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507252a8')) {
      api.createRecord('507252a8', component.options)
    } else {
      api.reload('507252a8', component.options)
    }
    module.hot.accept("./unfairModal.vue?vue&type=template&id=507252a8&scoped=true&", function () {
      api.rerender('507252a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/shortResume/unfairSupplier/unfairModal.vue"
export default component.exports